import * as d3 from 'd3';
import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: '[app-cbs-logo]',
  templateUrl: './cbs-logo.component.html',
  styleUrls: ['./cbs-logo.component.scss']
})
export class CbsLogoComponent implements OnInit, OnChanges {

  public d: string = 'M0,183.036729 L0,169.711001 L46.5928298,169.711001 L93.1856589,169.711001 L93.1856589,164.699481 L93.1856589,159.68771 L46.5928298,159.68771 L0,159.68771 L0,128.025046 L0,96.3621869 L59.999999,96.3621869 L120,96.3621869 L120,109.687825 L120,123.013275 L73.407173,123.013275 L26.8143202,123.013275 L26.8143202,128.025046 L26.8143202,133.03658 L73.407173,133.03658 L120,133.03658 L120,164.699481 L120,196.36218 L59.999999,196.36218 L0,196.36218 L0,183.036729 L0,183.036729 Z M112.573305,164.699481 L112.573305,140.418079 L65.9804497,140.418079 L19.3876192,140.418079 L19.3876192,127.986009 L19.3876192,115.554175 L65.9804497,115.554175 L112.573305,115.554175 L112.573305,109.648788 L112.573305,103.743637 L59.999999,103.743637 L7.42670096,103.743637 L7.42670096,128.025046 L7.42670096,152.306219 L54.0586406,152.306219 L100.690557,152.306219 L100.690557,164.699481 L100.690557,177.092493 L54.0586406,177.092493 L7.42670096,177.092493 L7.42670096,183.036729 L7.42670096,188.980689 L59.999999,188.980689 L112.573305,188.980689 L112.573305,164.699481 L112.573305,164.699481 Z M0,60.5812925 L0,29.3847189 L27.2442974,29.3847189 L54.488594,29.3847189 L54.488594,43.1376191 L54.488594,56.8905469 L40.6514693,56.8905469 L26.8143202,56.8905469 L26.8143202,61.0086311 L26.8143202,65.1267637 L40.6514693,65.1267637 L54.488594,65.1267637 L54.488594,78.4523045 L54.488594,91.777873 L27.2442974,91.777873 L0,91.777873 L0,60.5812925 L0,60.5812925 Z M47.0618931,78.4523045 L47.0618931,72.5082619 L33.2247447,72.5082619 L19.3876192,72.5082619 L19.3876192,61.0086311 L19.3876192,49.5090279 L33.2247447,49.5090279 L47.0618931,49.5090279 L47.0618931,43.603828 L47.0618931,37.698635 L27.2442974,37.698635 L7.42670096,37.698635 L7.42670096,61.0475014 L7.42670096,84.3963541 L27.2442974,84.3963541 L47.0618931,84.3963541 L47.0618931,78.4523045 L47.0618931,78.4523045 Z M60.8990185,44.0700369 L60.8990185,-3.63782 L74.3061925,-3.63782 L87.7133387,-3.63782 L87.7133387,12.8346137 L87.7133387,29.3070197 L103.856694,29.3070197 L120,29.3070197 L120,60.5424499 L120,91.777873 L90.4494988,91.777873 L60.8990185,91.777873 L60.8990185,44.0700369 Z M112.573305,61.0475014 L112.573305,37.698635 L96.4299705,37.698635 L80.2866363,37.698635 L80.2866363,20.7211635 L80.2866363,3.74369897 L74.3061925,3.74369897 L68.3257418,3.74369897 L68.3257418,44.0700369 L68.3257418,84.3963541 L90.4494988,84.3963541 L112.573305,84.3963541 L112.573305,61.0475014 L112.573305,61.0475014 Z M80.2866363,61.0087073 L80.2866363,49.5091041 L90.4886072,49.5091041 L100.690557,49.5091041 L100.690557,61.0087073 L100.690557,72.5083381 L90.4886072,72.5083381 L80.2866363,72.5083381 L80.2866363,61.0087073 Z M93.1856589,61.0475014 L93.1856589,56.9682461 L90.4494988,56.9682461 L87.7133387,56.9682461 L87.7133387,61.0475014 L87.7133387,65.1267637 L90.4494988,65.1267637 L93.1856589,65.1267637 L93.1856589,61.0475014 Z';
  public _scale: number = 1;
  public _color: string = '#00a1cd';
  public _bgFill: string = '#FFFFFF';
  public _borderRadius: number = 3 * 4;
  public _side: 'left' | 'right';
  public scaleString: string;


  constructor() { }

  ngOnInit() {
    if (!this._side) {
      this._side = 'left';
    }
  }

  @Input()
  set scale(s: number) {
    this._scale = s;
    this.scaleString = `scale(${this._scale},${this._scale})`;
  }

  @Input()
  set color(c: string) {
    this._color = c;
  }

  @Input()
  set bgFill(c: string) {
    this._bgFill = c;
  }

  @Input()
  set borderRadius(bR: number) {
    this._borderRadius = bR * 4;
  }

  @Input()
  set side(s: 'left' | 'right') {
    this._side = s;
  }

  ngOnChanges() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/cbs-logo/cbs-logo.component.ts